export default __webpack_public_path__ + "static/media/cif-mz.aaef0e63.svg";